export default __webpack_public_path__ + "static/13-25-a314cc95f31c2c6b29182f1eeeda8f23.png";